<template>
  <div class="scene-module scene-price">
    <v-drop-down-menu
      v-if="$store.state.sceneClassName === 'app'"
      :menu="menu"
      :active="1"
      className="app-company-nav"
    ></v-drop-down-menu>
    <div v-else id="navFooter" class="nav-footer">
      <div class="nav-footer__content">
        <div class="nav-footer__left">
          企业培训
          <span class="line">|</span>
          <a class="EC1" href="/" target="_blank"
            >企业微信版 <i class="iconfont iconskip_icon"></i>
          </a>
        </div>
        <div class="nav-footer__list">
          <router-link to="/scene/company" class="nav-footer__item">
            概览
          </router-link>
          <router-link
            to="/scene/price"
            class="nav-footer__item nav-footer__item-selected"
          >
            价格
          </router-link>
        </div>
      </div>
    </div>
    <div class="corporate-price">
      <div class="EC2 center pt80 mb80 title">知链企学院产品价格</div>
      <div class="corporate-price-content">
        <div class="blue-top">
          <div class="EC2 T3 mb8">
            针对中小型企业到<br
              v-if="$store.state.sceneClassName === 'app'"
            />大型企业的培训和学习需求
          </div>
          <p class="EC3 T7 mb24">
            帮助企业在员工培训计划、企业培训课程、学习效果可视化、智能管理台整合为一体的移动学习解决方案。
          </p>
          <div class="price-text">
            <span v-if="$store.state.sceneClassName !== 'app'" class="EC3 T7"
              >版本费：</span
            >
            <span class="EC2 T5">￥</span>
            <span class="EC1 price">990</span>
            <span class="EC2 T5">起/年</span>
          </div>
          <a
            target="_blank"
            href="https://admin.getchain.cn/login_page?from=training#/register"
            class="BigBtnType1 cor-btn"
            >免费试用7天</a
          >
        </div>
        <div class="content-detail-box">
          <div class="content-detail content-detail-left">
            <div class="EC2 mb16 detail-title">企学院包含功能</div>
            <ul class="detail-ul">
              <li>连接微信/企业微信等办公场景</li>
              <li>50万+内容满足培训内容采购</li>
              <li>支持定制课程、定制培训计划</li>
              <li>图文/音频/视频/直播内容形式</li>
              <li>支持H5页面等多种终端</li>
              <li>一键管理培训对象和讲师权限</li>
            </ul>
          </div>
          <div class="content-detail content-detail-right">
            <div class="EC2 mb16 detail-title">企学院包含服务</div>
            <ul class="detail-ul">
              <li>7*12小时专业售后顾问</li>
              <li>可添加3个管理员帐号</li>
              <li>商家学院线上课程（仅限公开课）</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="price-range">
        <div class="range-title">
          <div class="range">使用人数区间</div>
          <div class="price-title">定价</div>
        </div>
        <ul
          class="range-list EC2 ET7"
          :style="{ height: isOpen ? 'auto' : '561px' }"
        >
          <li>
            <div class="number">1-30人</div>
            <div class="price">33元/人，30人起购</div>
          </li>
          <li>
            <div class="number">31-200人</div>
            <div class="price">超过30人，每增加1人，增加30元</div>
          </li>
          <li>
            <div class="number">201-300人</div>
            <div class="price">超过200人，每增加1人，增加27元</div>
          </li>
          <li>
            <div class="number">301-500人</div>
            <div class="price">超过300人，每增加1人，增加26元</div>
          </li>
          <li>
            <div class="number">501-800人</div>
            <div class="price">超过500人，每增加1人，增加25元</div>
          </li>
          <li>
            <div class="number">801-1000人</div>
            <div class="price">超过800人，每增加1人，增加24元</div>
          </li>
          <li>
            <div class="number">1001-3000人</div>
            <div class="price">超过1000人，每增加1人，增加23元</div>
          </li>
          <li>
            <div class="number">3001-5000人</div>
            <div class="price">超过3000人，每增加1人，增加22元</div>
          </li>
          <li>
            <div class="number">5001-10000人</div>
            <div class="price">超过5000人，每增加1人，增加16元</div>
          </li>
          <li>
            <div class="number">10001-20000人</div>
            <div class="price">超过10000人，每增加1人，增加12元</div>
          </li>
          <li>
            <div class="number">20001-30000人</div>
            <div class="price">超过20000人，每增加1人，增加9元</div>
          </li>
          <li>
            <div class="number">30001-50000人</div>
            <div class="price">超过30000人，每增加1人，增加8元</div>
          </li>
          <li>
            <div class="number">50001-70000人</div>
            <div class="price">超过50000人，每增加1人，增加7元</div>
          </li>
          <li>
            <div class="number">70001-100000人</div>
            <div class="price">超过70000人，每增加1人，增加6元</div>
          </li>
        </ul>
        <div :class="`mask-layer ${isOpen ? 'hide' : ''}`">
          <span class="MediumBtnType2 spread" @click="openSee"
            >查看更高规模企业</span
          >
        </div>
      </div>
    </div>
    <div class="contact pt120 pb120">
      <div class="contact-title">
        还想了解什么？<br
          v-if="$store.state.sceneClassName === 'app'"
        />欢迎咨询知链客户经理
      </div>
      <div class="contact-phone">官方咨询热线：0592-5929181</div>
      <div class="contact-tips">大客户定制/购买咨询/产品咨询/优惠活动</div>
    </div>
    <v-free title="让企业拥有自己的企业大学" href=""></v-free>
  </div>
</template>

<script>
import DropDownMenu from '@/components/DropDownMenu';
import Free from '@/components/Free';
export default {
  data() {
    return {
      isOpen: false,
      menu: [{
        id: 1,
        title: '概览',
        showText: '企业培训',
        link: '/scene/company'
      }, {
        id: 2,
        title: '价格',
        showText: '企学院',
        link: '/scene/price'
      }]
    };
  },
  components: {
    'v-free': Free,
    'v-drop-down-menu': DropDownMenu
  },
  methods: {
    openSee() {
      this.isOpen = true;
    }
  }
};
</script>

<style lang="scss">
.scene-price {
  .title {
    font-size: 40px;
  }
  .corporate-price-content {
    width: 1110px;
    height: 621px;
    background: #fff;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.02),
      0 20px 40px 0 rgba(0, 0, 0, 0.04);
    border-radius: 8px;
    margin: 0 auto;
  }
  .corporate-price-content .blue-top {
    padding: 32px 56px;
    background: #f4f8ff;
    height: 217px;
    border-radius: 4px 4px 0 0;
    position: relative;
  }
  .corporate-price-content .blue-top .price {
    font-size: 40px;
    font-weight: 700;
  }
  .corporate-price-content .blue-top .cor-btn {
    position: absolute;
    bottom: 43px;
    right: 56px;
  }
  .corporate-price-content .content-detail-box {
    padding: 56px;
    display: flex;
  }
  .corporate-price-content .content-detail-box .content-detail {
    width: 50%;
  }
  .corporate-price-content .content-detail-box .detail-title {
    font-weight: 700;
    font-size: 18px;
  }
  .corporate-price-content .content-detail-box .detail-ul {
    font-size: 18px;
    color: #666;
    line-height: 40px;
  }
  .price-range {
    width: 1110px;
    margin: 88px auto 0;
    text-align: center;
    position: relative;
  }
  .price-range .range-list li .number,
  .price-range .range-title .price-title,
  .price-range .range-title .range {
    width: 50%;
  }
  .price-range .range-title {
    display: flex;
    background: #fbfbfb;
    font-size: 18px;
    color: #353535;
    height: 56px;
    line-height: 56px;
    border: 1px solid #eee;
  }
  .price-range .range-list {
    border-right: 1px solid #eee;
    border-left: 1px solid #eee;
    height: 561px;
    overflow: hidden;
  }
  .price-range .range-list li {
    display: flex;
    height: 52px;
    line-height: 52px;
    border-bottom: 1px solid #eee;
  }
  .price-range .range-list li .price {
    border-left: 1px solid #eee;
    width: 50%;
  }
  .price-range .mask-layer {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0, #fff 100%);
    position: absolute;
    height: 349px;
    width: 100%;
    bottom: 0;
  }
  .price-range .mask-layer .spread {
    margin-top: 357px;
  }
  .contact {
    text-align: center;
    color: #333;
  }
  .contact .contact-title {
    line-height: 50px;
    font-size: 30px;
    margin: 0 0 20px;
  }
  .contact .contact-phone,
  .contact .contact-tips {
    line-height: 20px;
  }
}
.app .scene-price {
  padding-top: 2.1rem;
  .app-company-nav {
    position: fixed;
    top: 1.04rem;
    left: 0;
    width: 100%;
    z-index: 8;
  }
  .title {
    color: #333;
    font-size: 0.48rem;
    margin-bottom: 1.28rem;
    padding: 0;
    font-weight: bold;
  }
  .corporate-price-content {
    height: auto;
    width: 6.7rem;
    margin: 0 auto;
    padding: 0.8rem 0.36rem;
    background: #fff;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.02),
      0 20px 40px 0 rgba(0, 0, 0, 0.04);
    border-radius: 0.16rem;
    text-align: center;
    .blue-top {
      height: auto;
      padding: 0;
      background: #fff;
      div:nth-child(1) {
        font-size: 0.36rem;
        color: #333;
        line-height: 0.64rem;
        margin-bottom: 0.12rem;
      }
      p {
        margin-bottom: 1.28rem;
        font-size: 0.24rem;
        color: #666;
        line-height: 0.56rem;
      }
      .price-text {
        span {
          color: #333;
          font-size: 0.4rem;
          line-height: 1.12rem;
        }
        .price {
          color: #1472ff;
          font-size: 40px;
          font-weight: normal;
        }
      }
      .cor-btn {
        position: static;
        padding: 0.14rem 0.64rem;
        margin-top: 0.4rem;
        font-size: 0.32rem;
        text-align: center;
        color: #fff;
        border-radius: 0.44rem;
        border: 0.02rem solid #1472ff;
        background: #1472ff;
        line-height: 1.5;
        height: auto;
      }
    }
    .content-detail-box {
      display: block;
      padding: 0;
      .content-detail {
        padding-top: 0.96rem;
        width: auto;
      }
      .detail-title {
        font-size: 0.28rem;
        line-height: 0.72rem;
        margin-bottom: 0.16rem;
      }
      .detail-ul {
        font-size: 0.28rem;
        line-height: 0.72rem;
      }
    }
  }
  .price-range {
    width: 6.7rem;
    margin: 1.6rem auto 0;
    range-title {
      font-size: 0.36rem;
      height: 1.12rem;
      line-height: 1.12rem;
    }
    .range-list {
      border-right: 0.02rem solid #eee;
      border-left: 0.02rem solid #eee;
      height: 12.22rem;
      li {
        align-items: center;
        height: 1.04rem;
        line-height: 1.5;
        border-bottom: 0.02rem solid #eee;
      }
      .price {
        border-left: 0.02rem solid #eee;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .contact {
    padding-bottom: 2.4rem;
    padding-top: 2.4rem;
    font-size: 0.28rem;
    color: #666;
    .contact-title {
      line-height: 0.68rem;
      font-size: 0.48rem;
      color: #333;
      margin-bottom: 8px;
    }
    .contact-phone,
    .contact-title {
      line-height: 1.5;
    }
  }
}
</style>
